import RegistrationDocumentsNavigation from 'Navigation/RegistrationDocumentsNavigation';
import Layout from "../../../Components/Layout/Layout";
import Imports from "../../Imports/Imports";

const VehicleRegistrationDocumentArrivalsImports = () => {
	return (
		<Layout
			title="Ankunft"
			navigation={<RegistrationDocumentsNavigation />}
		>
			<Imports importType="VehicleRegistrationDocumentArrivalsImport" />
		</Layout>
	);
};

export default VehicleRegistrationDocumentArrivalsImports;
